import { computed } from "vue";
import { mapText } from "#ce/apps/SpFinderMap/lib/map-text";

/** Returns the map pagination's count label, arrow states and actions for a results payload. */
export function useFinderMapPagination(props) {
  const page = computed(() => Number(props.payload.page) || 1);
  const previousClass = computed(() => ({ "pagination-item--disabled": page.value <= 1 }));
  const nextClass = computed(() => ({ "pagination-item--disabled": page.value >= props.payload.page_count }));
  const start = computed(() => (props.payload.result_count ? (page.value - 1) * props.payload.per_page + 1 : 0));
  const end = computed(() => Math.min(page.value * props.payload.per_page, props.payload.result_count));
  const countLabel = computed(() =>
    mapText("results_count", {
      start: start.value.toLocaleString(),
      end: end.value.toLocaleString(),
      count: Number(props.payload.result_count ?? 0).toLocaleString(),
    }),
  );
  const withinBoundsText = computed(() => ` ${mapText("within_bounds")}`);
  function changeMode(event) {
    props.viewport.changeMode(event.target.checked);
  }
  function previous() {
    props.commands.showPage(page.value - 1);
  }
  function next() {
    props.commands.showPage(page.value + 1);
  }
  return { page, previousClass, nextClass, countLabel, withinBoundsText, changeMode, previous, next };
}
